import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { cPackage } from 'src/types/package';
import { booking_returndata } from 'src/types/booking_returndata';
import { session } from 'src/types/session';

@Component({
  selector: 'app-managewaiver',
  templateUrl: './managewaiver.component.html',
  styleUrls: ['./managewaiver.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ManagewaiverComponent implements OnInit {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  waivers: any[];
  id: string | null = null;
  NewBooking: any;
  httpResponse: any;
  bookingDate: Date = new Date();
  packageName: string = "";
  totalWaiversSigned: any;
  totalParticipants: any;
  guestWaiverLink: any;
  emailAddress: string = "";
  emailAddressValid: boolean = true;
  returnDate: string | null = null;
  magicNumberExists: boolean = false;
  magicNumber: string = "";
  magicNumberExpiry: Date;

  constructor(private http: HttpClient, private messageService: MessageService, private route: ActivatedRoute, private router: Router) { }
  
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.returnDate = this.route.snapshot.queryParamMap.get('returnDate');

      this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
        
        this.NewBooking = (response as any).data;

        if(this.NewBooking.magicnumber  && this.NewBooking.magicnumber.trim() !== "")
        {
          this.magicNumber = this.NewBooking.magicnumber;

          this.magicNumberExpiry = new Date(this.NewBooking.magicnumberexpiry);

          if(this.magicNumberExpiry > new Date())
          {
            this.magicNumberExists = true;
          }
          else
          {
            this.magicNumberExists = false;
          }
          
        }
      
        this.packageName = this.NewBooking.packageName;
        const st = this.NewBooking.startTime ?? '';
        this.bookingDate = new Date(st.endsWith('Z') ? st.slice(0, -1) : st);
      
        if (this.id) {
          this.GetWaiver(this.id);
        } else {
          this.messageService.add({severity:'error', summary:'Error', detail: 'No booking ID provided in URL.'});
        }

      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to get booking details'});
      }
    );
  }

  createMagicNumber(){
    this.http.get<any>(bmxurl + "generatemagicnumber/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      if(response.succeeded)
      {
        this.magicNumber = response.data.magicnumber;
        this.magicNumberExists = true;
        this.messageService.add({severity:'success', summary:'Success', detail:'Magic Number created.'});
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to create Magic Number: ' + response.messages[0]});
      }
  }
  , error => {
    this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to create Magic Number'});
  }
  );
  }

  // admitall(){
  //   this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
  //     this.httpResponse = response
  //     if(this.httpResponse.succeeded)
  //     {
  //       this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this booking.'});

  //       // Use the session datetime from the originating at-a-glance time slot (returnDate),
  //       // falling back to the booking's own start time for the QR scan flow.
  //       const sessionDateTime = this.returnDate ? new Date(this.returnDate) : this.bookingDate;

  //       const newSession: session = {
  //         id: null,
  //         venueid: this.VenueID,
  //         datetime: sessionDateTime,
  //         started: true
  //       };

  //       this.http.post<any>(bmxurl + "CountersSession", newSession).subscribe(() => {}, () => {});

  //       this.router.navigateByUrl("/ataglance/" + this.bookingDate.getFullYear() + '-' + String(this.bookingDate.getMonth() + 1).padStart(2, '0') + '-' + String(this.bookingDate.getDate()).padStart(2, '0'));
  //     }
  //   }, error => {
  //     this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
  //   })
  // }

  get isBookingDateToday(): boolean {
    if (!this.bookingDate) return false;
    const today = new Date();
    return this.bookingDate.getFullYear() === today.getFullYear()
      && this.bookingDate.getMonth() === today.getMonth()
      && this.bookingDate.getDate() === today.getDate();
  }

  admitall(Id)
  {
    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + Id).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers have been marked as \'admitted\' for this booking.'});
        this.returnToBookingBlock();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    })
  }

  copyData(){
    navigator.clipboard.writeText(this.guestWaiverLink);
    this.messageService.add({severity:'success', summary:'Success', detail: 'Guest Waiver Link Copied to Clipboard'});
  }

  sendEmailConfirmation(){
     this.http.get<any>(bmxurl + "confirmationemail/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
     })
  }

  sendWaiverLinkEmail(){
    if(this.emailAddress.trim() === "" || !this.emailAddress.includes("@")) {
      this.emailAddressValid = false;
      return;
    } else {
      this.emailAddressValid = true;

      let emailDetails= {
        venueid: this.VenueID,
        bookingid: this.NewBooking.bookingId,
        email: this.emailAddress
      }

      this.http.post<any>(bmxurl + "waiverrequest", emailDetails).subscribe(response => {
        this.messageService.add({severity:'success', summary:'Success', detail:'Waiver Link Email sent.'})
        this.emailAddress = "";
      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Waiver Link Email'});
      });
    }
  }

  refreshData(): void {
    if (this.id) {
      this.GetWaiver(this.id);
      this.messageService.add({severity:'success', summary:'Success', detail: 'Data refreshed successfully'});
    }
  }

  changeParticipant(waiver: any){
    
    this.http.get<any>(bmxurl + "updatebookingwaiverparticipant/" + this.VenueID + "/" + waiver.waiverid + "/" + (!waiver.participant)).subscribe(response => { 
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Participant status updated.'});
        this.GetWaiver(this.id!);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to update participant status: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to update participant status'});
    });
  } 

  GetWaiver(bookingId)
    {
      this.http.get<any>(bmxurl + "bookingwaiversummaryvenue/" + this.VenueID + "/" + bookingId).subscribe(response => {
        if(response.succeeded)
        {
          this.waivers = response.data.waivers
          this.totalWaiversSigned = response.data.totalwaivers;
          this.totalParticipants = response.data.totalparticipants; 
          this.guestWaiverLink = response.data.guestwaiverlink;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to get waivers: ' + response.messages[0]});
        }
        
      }, error => {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to get waivers'});
      })
    }

    returnToBookingBlock(): void {
      if (this.returnDate) {
        this.router.navigateByUrl("/bookingblock/" + this.returnDate);
      } else {
        // Default to current date if no returnDate is provided
        const today = new Date();
        const dateString = today.getFullYear() + '-' + 
          String(today.getMonth() + 1).padStart(2, '0') + '-' + 
          String(today.getDate()).padStart(2, '0');
        this.router.navigateByUrl("/bookingblock/" + dateString);
      }
    }
  
}


